function isInViewport(theDiv) {
  let elementTop = theDiv.offset().top;
  let elementBottom = elementTop + theDiv.outerHeight();
  let viewportTop = $(window).scrollTop();
  let viewportBottom = viewportTop + window.innerHeight;
  return elementBottom > viewportTop && elementTop < viewportBottom;
}
$(document).ready(function(){
  var animationDone = false;
  if ($('#product-block-tested').length) {
    $(window).on('scroll', function(){
      if (!animationDone) {
        if(isInViewport($('#product-block-tested'))) {
          animationDone = true;
          $(".circleBarProgress").each(function () {
            var t = $(this).find(".circleBar"),
                x = $(this).find(".circleBarWrapper"),
                i = $(this).find("span"),
                e = parseInt(i.text(), 10);
            $({ p: 0 }).animate(
                { p: e },
                {
                    duration: 3e3,
                    easing: "swing",
                    step: function (e) {
                        x.css({background: "conic-gradient(#FFCC66 0deg " + e + "%, #ffffff " + e + "%)"}), i.text(0 | e);
    
                    },
                }
            );
          });
        }
      }
    });
  }
});